import React, { Fragment, useState, useEffect } from "react"
import DatePicker from "react-datepicker"
import Select from "react-select"
import {
  Col,
  Collapse,
  Label,
  Row,
  Form,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"
import { uniqBy } from "lodash"
import classnames from "classnames"
import { setModeCompact } from "../../../common/data/settings"
import CustomSelectwithLabel from "components/Common/CustomSelectwithLabel"
// Define a default UI for filtering

const FilterLayout = props => {
  const {
    teamsReportList,
    handleSubmit,
    MainCategory,
    companySetting,
    teams,
    handleNameDropdownFilter,
    selectToggle,
    handleSubmitteam,
    toggleChecked,
    setSelectedclientId,
    setSelectedprojectId,
    setSelecteduserd,
    getallbillingtypes,
    loadTeamScreenteam
  } = props

  const clientList = [
    {
      label: "All",
      value: "11",
    },
  ]
  const projectsList = [
    {
      label: "All",
      value: "11",
    },
  ]
  const namesList = [
    {
      label: "All",
      value: "11",
    },
  ]



  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const bookmark = JSON.parse(localStorage.getItem("bookmark"))
  const maincategory = MainCategory?.sort(SortArray)
  const accessgroupname = authUser?.data?.accessgroupname

  const [isadvancefilter, setisadvancefilter] = useState(false)
  const [filteredDates, setFilteredDates] = useState(new Date())
  const [selectedClient, setSelectedClient] = useState(clientList[0])
  const [selectedProject, setSelectedProject] = useState(projectsList[0])
  const [selectname, setSelectname] = useState(namesList[0])
  const [ids, setids] = useState(null)
  const [filtersub, setfiltersub] = useState(null)
  const [favourite, setFavorite] = useState(false)

  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }

  const startDateChange = date => {
    props.setStartDate(date)
    if (date) {
      const oneWeekLater = new Date(date)
      oneWeekLater.setDate(oneWeekLater.getDate() + 7)
      setFilteredDates(oneWeekLater)
    } else {
      setFilteredDates(new Date())
    }
  }
  const endDateChange = date => {
    props.setEndDate(date)
  }

  const toggleAdvanceFilter = e => {
    e.preventDefault()
    setisadvancefilter(!isadvancefilter)
  }

  const toggleBookMarkFilter = () => {
    localStorage.setItem('bookmark', !favourite)
    setFavorite(!favourite)
    loadTeamScreenteam()
  }


  const projectFilter = value => {
    setSelectedprojectId(value)
    props.handleProjectFilter(value)
    setSelectedProject(value)
  }

  const clientFilter = value => {
    props.handleClientFilter(value)
    setSelectedclientId(value)
    setSelectedClient(value)
    setids(value)
    setSelectedProject(null)
  }

  const handleNameFilter = value => {
    setSelectname(value)
    setSelecteduserd(value?.id)
    handleNameDropdownFilter(value)
  }

  var mergeMainCategory = maincategory?.map(item => ({
    clientName: item.name,
    id: item.id,
  }))


  useEffect(() => {
    const filteredData = ids?.id
      ? teams?.filter(el => el?.categoryId === ids?.id)
      : teams
    setfiltersub(filteredData)
  }, [ids])

  var mergeSubCategory = filtersub?.map(item => ({
    projectName: item?.name,
    id: item?.id,
    categoryId: item?.categoryId
  }))

  const ReportStatusArr = [
    { label: "Ready", value: "Ready" },
    { label: "Submitted", value: "Submitted" },
    { label: "Report Not Submitted", value: "Report Not Submitted" },
    { label: "Screen Not Verified", value: "Screen Not Verified" },
  ]

  useEffect(() => {
    if (accessgroupname !== "Admin") {
      if (filteredDates <= new Date()) {
        props.setEndDate(filteredDates)
      } else {
        const currentdate = new Date();
        props.setEndDate(currentdate.toDateString() == props?.startDate.toDateString() ? currentdate : props?.endDate)
      }
    }
  }, [filteredDates, accessgroupname])

  useEffect(() => {
    setFavorite(bookmark)
  }, [])

  // billable type add all concept
  const getbilltypeChange = getallbillingtypes ? [
    { id: 0, label: "All", value: "All" },
    ...getallbillingtypes?.map(item => ({ id: item.id, label: item.name, value: item.name }))
  ] : [];

  return (
    <Fragment>
      <Row className="mb-2 myhours-page">
        <Col sm="12" className="d-flex justify-content-end mobile_filter">
          <Row className="navtab-main mb-4 toggle-team-ui">
            <Nav
              pills
              className="navtab-bg nav-justified"
              style={{ width: "260px" }}
            >
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: !selectToggle,
                  })}
                  onClick={() => {
                    toggleChecked(false);
                    setisadvancefilter(false);
                  }}
                >
                  By Project
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  style={{ cursor: "pointer" }}
                  className={classnames({
                    active: selectToggle,
                  })}
                  onClick={() => {
                    toggleChecked(true);
                    setisadvancefilter(false);
                  }}
                >
                  By User
                </NavLink>
              </NavItem>
            </Nav>
          </Row>
          <Form onSubmit={handleSubmit}>
            <div className="text-sm-end">
              {(!selectToggle || selectToggle) && (
                <div className=" d-flex text-sm-end mobile_responsive_filter align-items-center">
                  <div className="mx-2">
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={props.startDate}
                      onChange={startDateChange}
                      className="form-control mb-0 date-icon-back"
                      placeholderText="Select date"
                      maxDate={new Date()}
                    />
                  </div>
                  <div className="mx-2">
                    <DatePicker
                      dateFormat="yyyy-MM-dd"
                      selected={props.endDate}
                      onChange={endDateChange}
                      className="form-control mb-0 date-icon-back"
                      placeholderText="Select date"
                      minDate={new Date(props.startDate)}
                      maxDate={
                        accessgroupname === "Admin" ? new Date() : filteredDates
                      }
                    />
                  </div>
                  <div className="mx-2">
                    <button
                      className="btn btn-primary "
                      type="submit"
                      onClick={selectToggle ? handleSubmit : handleSubmitteam}
                    >
                      <i className="bx bx-filter-alt align-middle"></i> Filter
                    </button>
                  </div>

                  <div className="mx-2">
                    <button
                      onClick={e => toggleAdvanceFilter(e)}
                      className="btn btn-primary"
                    >
                      <i className="bx bx-filter-alt align-middle"></i> Advance
                    </button>
                  </div>

                 {!selectToggle && <div className="mx-2">
                    <i onClick={e => toggleBookMarkFilter(e)}
                      className={classnames("fas fa-star", favourite ? "text-primary" : "text-lightgray")}
                      style={{ fontSize: "16px", cursor: "pointer", opacity: favourite ? 1 : 0.15 }}
                    >
                    </i>
                  </div>}
                </div>
              )}
            </div>
          </Form>
        </Col>
        <Col sm="12" className="mt-2 mb-2">
          <Collapse isOpen={isadvancefilter} className="mt-2">
            <Row>
              <Col md="12">
                <Row>
                  {selectToggle && (
                    <CustomSelectwithLabel
                      label="Name"
                      isClearable
                      value={selectname}
                      placeholder="All"
                      onChange={value => handleNameFilter(value)}
                      options={[{ label: "All" }].concat(uniqBy(teamsReportList, "userId")?.map(el => ({ label: el.displayName, value: el.userId })))}
                    />
                  )}
                  {!selectToggle && (
                    <CustomSelectwithLabel
                      label={companySetting?.MainCategory}
                      isClearable
                      value={selectedClient}
                      placeholder="All"
                      onChange={value => clientFilter(value)}
                      options={[{ label: "All" }].concat(mergeMainCategory?.map(el => ({ ...el, label: el?.clientName, value: el?.clientName })))}
                    />
                  )}
                  {!selectToggle && (
                    <CustomSelectwithLabel
                      label={companySetting?.SubCategory}
                      isClearable
                      value={selectedProject}
                      placeholder="All"
                      onChange={value => projectFilter(value)}
                      options={[{ label: "All" }].concat((mergeSubCategory || [])?.map(el => ({ ...el, label: el?.projectName, value: el?.projectName })))}
                    />
                  )}

                  <CustomSelectwithLabel
                    label={!selectToggle ? 'Hours Team' : 'Hours'}
                    isClearable
                    isMulti={true}
                    value={!selectToggle ? props.selectedHoursteam : props.selectedHours}
                    placeholder="Select..."
                    onChange={value => {
                      if (!selectToggle) {
                        props.handleHoursFilterteam(value)
                      } else {
                        props.handleHoursFilter(value)
                      }
                    }}
                    options={(!selectToggle ? props.hoursListteam : props.hoursList)?.map(el => ({
                      ...el,
                      label: el.label,
                      value: el.value,
                    }))}
                  />

                  {(!selectToggle || selectToggle) && (
                    <CustomSelectwithLabel
                      label='Report Status'
                      value={props.activeReportStatus}
                      placeholder="Select..."
                      onChange={value => props.handleReportFilter(value)}
                      options={ReportStatusArr}
                      isClearable
                    />
                  )}
                  {(!selectToggle || selectToggle) && (
                    <CustomSelectwithLabel
                      label='Mode'
                      value={props.modeCompact}
                      placeholder="Select..."
                      onChange={value => props.handleCompactFilter(value)}
                      options={setModeCompact}
                    />
                  )}
                  {!selectToggle &&
                    <CustomSelectwithLabel
                      label="Type"
                      value={props.billableType}
                      placeholder="Select..."
                      onChange={value => props.handlebillableFilter(value)}
                      options={getbilltypeChange}
                      isClearable={true}
                    />
                  }
                </Row>
              </Col>
            </Row>
          </Collapse>
        </Col>
      </Row>
    </Fragment>
  )
}

export default FilterLayout
